import { render, staticRenderFns } from "./detailImgList.vue?vue&type=template&id=b4274c8e&scoped=true&"
import script from "./detailImgList.vue?vue&type=script&lang=js&"
export * from "./detailImgList.vue?vue&type=script&lang=js&"
import style0 from "./detailImgList.vue?vue&type=style&index=0&id=b4274c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4274c8e",
  null
  
)

export default component.exports